import { render } from "./securities-list-page.vue?vue&type=template&id=44b7eaf4&scoped=true"
import script from "./securities-list-page.vue?vue&type=script&lang=js"
export * from "./securities-list-page.vue?vue&type=script&lang=js"

import "./securities-list-page.vue?vue&type=style&index=0&id=44b7eaf4&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b7eaf4"]])

export default __exports__